export const TableWrapper = ({ children }: any) => {
  return <div className="table-wrapper" data-testid="table-wrapper-box">{children}</div>;
};
